document.addEventListener('change', function (event) {
  const select = event.target.closest('[data-upsell-variant-select]');
  if (!select) return;

  const wrapper = select.closest('[data-upsell]');
  if (!wrapper) return;

  const selectedOption = select.options[select.selectedIndex];
  const variantId = select.value;
  const price = selectedOption.dataset.price;
  const image = selectedOption.dataset.image;

  const button = wrapper.querySelector('[data-upsell-add]');
  const priceEl = wrapper.querySelector('[data-upsell-price]');
  const imageEl = wrapper.querySelector('.qnk-upsell__image');

  if (button) {
    button.setAttribute('data-variant-id', variantId);
    button.disabled = selectedOption.disabled;
    button.textContent = selectedOption.disabled ? 'Agotado' : 'Añadir';
  }

  if (priceEl && price) {
    priceEl.textContent = price;
  }

  if (imageEl && image) {
    imageEl.src = image;
    imageEl.srcset = '';
  }
});

document.addEventListener('click', async function (event) {
  const button = event.target.closest('[data-upsell-add]');
  if (!button || button.disabled) return;

  const variantId = button.getAttribute('data-variant-id');
  if (!variantId) return;

  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = 'Añadido';

  try {
    const payload = {
      items: [
        {
          id: Number(variantId),
          quantity: 1,
          properties: {
            _upsell: 'true'
          }
        }
      ]
    };

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error('No se pudo añadir el producto');
    }

    window.dispatchEvent(new CustomEvent('cart:refresh'));
  } catch (error) {
    console.error(error);
    button.textContent = 'Error';
  }

  setTimeout(() => {
    button.disabled = false;
    button.textContent = originalText;
  }, 1400);
});